import React from 'react';
import { Provider } from 'react-redux';
import store from './store';

const TransReportsCenterProvider = (WrappedComponent: any) => (props: any) => {
  return (
    <Provider store={store}>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <WrappedComponent {...props} />
    </Provider>
  );
};

export default TransReportsCenterProvider;
